module.exports = __webpack_public_path__ + "media/images/contacts-map-01-d34896830e8f420df655eb899694cc5c.svg";